<template>
  <div class="jd-apply" :class="{ 'jd-apply--compact': compact }">
    <template v-if="!applied && !expired && job">
      <button
        v-if="job.response_type === 1"
        type="button"
        class="hp-btn"
        :class="compact ? 'hp-btn--primary jd-apply__btn--block' : 'hp-btn--primary'"
        @click="$emit('apply')"
      >Apply now</button>

      <div v-if="job.response_type === 2" class="jd-apply__external">
        <div v-if="job.title_description && !compact" class="jd-apply__howto" v-html="job.title_description"></div>
        <button type="button" class="hp-btn hp-btn--primary" :class="{ 'jd-apply__btn--block': compact }" @click="$emit('apply')">
          {{ applyLabel }}
        </button>
      </div>
    </template>

    <button v-if="applied && !expired && (!hasQuestionnaire || qResult > 0)" type="button" class="hp-btn jd-apply__btn--disabled" disabled>Applied</button>
    <button v-if="applied && !expired && hasQuestionnaire && qResult === 0" type="button" class="hp-btn jd-apply__btn--warning" disabled>Partially applied</button>
    <button v-if="!applied && expired" type="button" class="hp-btn jd-apply__btn--disabled" disabled>Expired</button>

    <p v-if="error" class="jd-apply__error">{{ errMsg }}</p>
  </div>
</template>

<script>
import { getApplyButtonLabel } from '@/utils/formatJob';

export default {
  name: 'JobDetailApply',
  props: {
    job: { type: Object, default: null },
    applied: { type: Boolean, default: false },
    expired: { type: Boolean, default: false },
    qResult: { type: Number, default: 0 },
    hasQuestionnaire: { type: Boolean, default: false },
    error: { type: Boolean, default: false },
    errMsg: { type: String, default: null },
    compact: { type: Boolean, default: false },
  },
  computed: {
    applyLabel() {
      return getApplyButtonLabel(this.job && this.job.label1);
    },
  },
};
</script>
